import { render, staticRenderFns } from "./OrdersFBMTable.vue?vue&type=template&id=6a12c03c&scoped=true"
import script from "./OrdersFBMTable.vue?vue&type=script&lang=js"
export * from "./OrdersFBMTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a12c03c",
  null
  
)

export default component.exports